import {
  boolean,
  number,
  object,
  string,
} from 'yup';

import MESSAGE from 'validations/constants/messages';

export const companyFormSchema = object()
  .shape({
    id: number()
      .integer()
      .positive(),
    name: string()
      .trim()
      .nullable()
      .required(MESSAGE.REQUIRED),
    street_address: string()
      .trim()
      .nullable(),
    city: string()
      .trim()
      .nullable(),
    zipcode: string()
      .trim()
      .nullable(),
    state: string()
      .trim()
      .nullable(),
    country: string()
      .trim()
      .nullable(),
    email: string()
      .email(MESSAGE.EMAIL)
      .required(MESSAGE.REQUIRED),
    public_key: string()
      .nullable(),
    logo: object()
      .shape({
        imagotipoDarkH: string()
          .url(MESSAGE.URL),
        imagotipoHorizontal: string()
          .url(MESSAGE.URL),
      }),
    theme: object()
      .shape({
        primary: string(),
        secondary: string(),
      }),
    site: object()
      .shape({
        config: object()
          .shape({
            security: object()
              .shape({
                global_sign_out: boolean().default(true),
                recommendMFA: boolean().default(false),
              }),
          }),
        favicon: string()
          .url(MESSAGE.URL),
        privacy_notice: string()
          .url(MESSAGE.URL),
        terms_sheet: string()
          .url(MESSAGE.URL),
        title: string()
          .trim(),
      })
      .default({}),
  });
